import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Card, CardContent, Stack, Typography } from '@mui/material';
import { SocraticPracticeExperience } from '../portal-v2/components/SocraticPracticeExperience';

// Staff-facing view of the PRACTICE (self-study) dimension. Staff can try the same
// practice experience students use (the student entry lives in the portal). This
// page also points staff to where EVALUATED socratic dialogues are created.
export function SocraticConsolePage(): JSX.Element {
  const { t } = useTranslation('sis');
  const navigate = useNavigate();

  return (
    <Box sx={{ maxWidth: 820, mx: 'auto', p: { xs: 2, md: 3 } }}>
      <Typography variant="h5" fontWeight={700} gutterBottom>
        {t('socraticConsole.title')}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        {t('socraticPractice.intro')}
      </Typography>

      <SocraticPracticeExperience />

      <Card variant="outlined" sx={{ mt: 4 }}>
        <CardContent>
          <Stack spacing={1.5} alignItems="flex-start">
            <Typography variant="subtitle1" fontWeight={700}>
              {t('socraticConsole.evalHere.title')}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {t('socraticConsole.evalHere.body')}
            </Typography>
            <Button variant="outlined" onClick={() => navigate('/curso')}>
              {t('socraticConsole.evalHere.cta')}
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}
